/*
    自定义 toast 组件
    调用
    this.$cToast('hello world~', 1500)
*/

let _TOAST = {
    show: false,    // Boolean toast显示状态
    component: null // Object toast组件
};

export default {
    install(Vue) {
        /*
            text: String*
            during: Number
        */
        Vue.prototype.$cToast = function(text, t) {
            let duration = t || 2000;
            if (_TOAST.show) {
                return;
            }
            if (!_TOAST.component) {
                let ToastComponent = Vue.extend({
                    data: function() {
                        return {
                            show: _TOAST.show,
                            text: text
                        }
                    },
                    render: function (createElement) {
                        return createElement('div', {
                            'class': {
                                'cg-toast': true,
                                'cg-toast-show': this.show
                            }
                        }, this.text)
                    }
                });
                _TOAST.component = new ToastComponent();
                let element = _TOAST.component.$mount().$el;
                document.body.appendChild(element)
             
            }
            _TOAST.component.text = text;
            _TOAST.component.show = _TOAST.show = true;
            setTimeout(function() {
                _TOAST.component.show = _TOAST.show = false;
            }, duration)
        }
    }
};